import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';

interface CloudflareTurnstileProps {
  onVerify: (token: string) => void;
  onError?: () => void;
  onExpire?: () => void;
}

const CloudflareTurnstile: React.FC<CloudflareTurnstileProps> = ({
  onVerify,
  onError,
  onExpire
}) => {
  const siteKey = import.meta.env.VITE_CLOUDFLARE_TURNSTILE_SITE_KEY;

  // If no site key is configured, don't render anything
  if (!siteKey || siteKey === 'your-site-key-here' || siteKey === 'your-production-site-key-here') {
    console.warn('Cloudflare Turnstile site key not configured');
    return null;
  }

  return (
    <div className="flex justify-center">
      <Turnstile
        siteKey={siteKey}
        onSuccess={onVerify}
        onError={onError}
        onExpire={onExpire}
        options={{
          theme: 'dark',
          size: 'normal'
        }}
      />
    </div>
  );
};

export default CloudflareTurnstile;
